(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("./modules/reset");
require("./modules/club_settings");
require("./modules/edit_contact");
require("./modules/event_edit");

},{"./modules/club_settings":2,"./modules/edit_contact":3,"./modules/event_edit":4,"./modules/reset":5}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* global SITEPATH other_team_players total_days_left */
// Create a Stripe client.
var ClubSettingPage = {
  init: function init() {
    $(document).on('click', '.js-upload-box', ClubSettingPage.triggerLogoInput);
    $(document).on('change', '.change_logo_image', ClubSettingPage.submitClubImage);
    $(document).on('change', '.change_cover_image', ClubSettingPage.submitClubImage);
    $(document).on('change', '.change_emai_header', ClubSettingPage.submitClubImage);
    $(document).on('change', '.js-club-field', ClubSettingPage.updateClubInfo);
    $(document).on('change', '#howDidYouFindUsInput', ClubSettingPage.updateHowDidYouFindUsInput);
    $(document).on('click', '.deleteHDYFU', ClubSettingPage.deleteHDYFU);
  },
  fetchAjaxData: function fetchAjaxData(data, ajaxurl) {
    return $.ajax({
      type: 'POST',
      url: ajaxurl,
      cache: false,
      dataType: 'json',
      data: data
    });
  },
  triggerLogoInput: function triggerLogoInput(e) {
    e.preventDefault();
    var $button = $(e.currentTarget);
    var id = $button.attr('id');
    $('.' + id).trigger('click');
  },
  submitClubImage: function submitClubImage(e) {
    var _$$ajax;
    var $button = $(e.currentTarget);
    var form_id = $button.closest('form').attr('id');
    var form = $('#' + form_id)[0];
    $('.ajaxLoader').show();
    $.ajax((_$$ajax = {
      type: "POST",
      url: "index.php?option=com_membership&task=updateClubImages",
      cache: false,
      dataType: 'json',
      data: new FormData(form),
      contentType: false
    }, _defineProperty(_$$ajax, "cache", false), _defineProperty(_$$ajax, "processData", false), _defineProperty(_$$ajax, "success", function success(html) {
      if (typeof html.error != 'undefined' && html.error == '0') {
        location.reload();
      } else {
        alert('Unable to save');
        $('.ajaxLoader').hide();
      }
    }), _$$ajax)); //ajax
  },
  updateClubInfo: function updateClubInfo(e) {
    var $input = $(e.currentTarget);
    var value = $input.val();
    var name = $input.attr('name');
    if (jQuery(this).hasClass('required') && value == '') {
      jQuery(this).addClass('error');
      return false;
    } else {
      jQuery(this).removeClass('error');
    }
    jQuery.ajax({
      type: "POST",
      url: "index.php?option=com_membership&task=updateClubInfo",
      cache: false,
      dataType: 'json',
      data: {
        value: value,
        name: name
      },
      success: function success(html) {
        if (typeof html.error != 'undefined' && html.error == '0') {
          $input.addClass('success');
          setTimeout(function () {
            $input.removeClass('success');
          }, 1000);
        } else {
          alert('Unable to save');
        }
      } //success
    }); //ajax

    return false;
  },
  updateHowDidYouFindUsInput: function updateHowDidYouFindUsInput(e) {
    var $input = $(e.currentTarget);
    var value = $input.val();
    if (jQuery(this).hasClass('required') && value == '') {
      return false;
    }
    jQuery.ajax({
      type: "POST",
      url: "index.php?option=com_membership&task=updateHowDidYouFindUs",
      cache: false,
      dataType: 'json',
      data: {
        value: value
      },
      success: function success(html) {
        if (typeof html.error != 'undefined' && html.error == '0') {
          $input.addClass('success');
          setTimeout(function () {
            $input.removeClass('success');
            $input.val('');
            $('.howDidYouFindUs li:eq(0)').after('<li class="new_add">' + value + '</li>');
          }, 1000);
        } else {
          alert('Unable to save');
        }
      } //success
    }); //ajax

    return false;
  },
  deleteHDYFU: function deleteHDYFU(e) {
    var $button = $(e.currentTarget);
    var id = $button.attr('data-id');
    jQuery.ajax({
      type: "POST",
      url: "index.php?option=com_membership&task=deleteHowDidYouFindUs",
      cache: false,
      dataType: 'json',
      data: {
        id: id
      },
      success: function success(html) {
        if (typeof html.error != 'undefined' && html.error == '0') {
          $button.closest('li').remove();
        } else {
          alert('Unable to delete');
        }
      } //success
    }); //ajax

    return false;
  }
};
if ($('#js-club-setting-page').length > 0) {
  ClubSettingPage.init();
}

},{}],3:[function(require,module,exports){
"use strict";

/* global SITEPATH  */

var ProfilePage = {
  init: function init() {
    jQuery(document).on('change', '.updateField', ProfilePage.UpdateMembershipInfo);
    jQuery(document).on('change', '#js-email-field', ProfilePage.checkUniqueEmail);
    jQuery(document).on('click', '#js-change-password', ProfilePage.changePassword);
  },
  fetchAjaxData: function fetchAjaxData(data, ajaxurl) {
    return jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      cache: false,
      dataType: 'json',
      data: data
    });
  },
  changePassword: function changePassword(e) {
    e.preventDefault();
    var $button = jQuery(e.currentTarget);
    if ($button.hasClass('disabled')) return;
    var password = jQuery('.password').val();
    var password1 = jQuery('.password1').val();
    var member_id = $button.attr('data-id');
    jQuery('.password-details-form .required').each(function () {
      if (jQuery(this).val() == '' || jQuery(this).val() == null) {
        jQuery(this).addClass('error');
      } else {
        jQuery(this).removeClass('error');
      }
    });
    if (jQuery('.password-details-form .required').hasClass('error')) {
      return false;
    }
    if (password == password1) {
      jQuery('.password_errors').html('');
      jQuery('.password1').removeClass('error');
    } else {
      jQuery('.password_errors').html('Password doesn\'t match');
      jQuery('.password1').addClass('error');
      return false;
    }
    var data = {
      password: password,
      password1: password1,
      member_id: member_id
    };
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=changePassword";
    $button.addClass('disabled');
    ProfilePage.fetchAjaxData(data, ajaxurl).done(function (html) {
      if (typeof html.error != 'undefined' && html.error == '0') {
        $button.html('Password Changed');
        jQuery('.password').val('');
        jQuery('.password1').val('');
      } else {
        jQuery('.password_errors').html(html.message);
        jQuery('.password1').addClass('error');
        $button.removeClass('disabled');
      }
    });
    return false;
  },
  UpdateContactEmail: function UpdateContactEmail(name, value) {
    var contact_id = $('#contact_id').val();
    var $input = $('#js-email-field');
    var $inputContainer = $input.closest('.input_icon_contaner');
    var data = {
      name: name,
      value: value,
      contact_id: contact_id
    };
    $inputContainer.addClass('form-processing');
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=update_membership_info";
    ProfilePage.fetchAjaxData(data, ajaxurl).done(function (html) {
      $inputContainer.removeClass('form-processing');
      if (typeof html.error != 'undefined' && html.error == '0') {
        $inputContainer.addClass('form-saved');
      } else {
        $inputContainer.addClass('form-error');
      }
    });
  },
  UpdateMembershipInfo: function UpdateMembershipInfo(e) {
    var $input = $(e.currentTarget);
    var value = $input.val();
    var name = $input.attr('name');
    var contact_id = $('#contact_id').val();
    if (name == 'email') {
      return false;
    }
    var data = {
      name: name,
      value: value,
      contact_id: contact_id
    };
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=update_membership_info";
    ProfilePage.fetchAjaxData(data, ajaxurl).done(function (html) {
      if (typeof html.error != 'undefined' && html.error == '0') {
        $input.addClass('is-valid');
      } else {
        $input.addClass('is-invalid');
      }
    });
  },
  checkUniqueEmail: function checkUniqueEmail() {
    var $input = $('#js-email-field');
    var value = $input.val();
    var currentValue = $input.data('value');
    if (value == '') {
      $input.addClass('error');
      return false;
    } else if (value && currentValue != value) {
      var result = ProfilePage.validateEmail(value);
      if (!result) {
        $input.addClass('error');
        return false;
      }
    } else if (currentValue == value) {
      $input.removeClass('error');
      $('.error_message').hide();
      return false;
    }
    var data = {
      email: value
    };
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=checkEmailExists";
    ProfilePage.fetchAjaxData(data, ajaxurl).done(function (html) {
      if (typeof html.error != 'undefined' && html.error == '0') {
        $input.addClass('error');
        $('.error_message').show();
        return false;
      } else {
        ProfilePage.UpdateContactEmail('email', value);
        $input.removeClass('error');
        $('.error_message').hide();
      }
    });
  },
  validateEmail: function validateEmail(mail) {
    var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(String(mail).toLowerCase());
  }
};
$(document).ready(function () {
  if ($('#js-profile-page').length > 0) {
    ProfilePage.init();
  }
});

},{}],4:[function(require,module,exports){
"use strict";

var EventEditPage = {
  init: function init() {
    jQuery(document).on('change', '#rec_country', EventEditPage.getStates);
    jQuery(document).on('change', '#rec_state', EventEditPage.getCities);
  },
  fetchAjaxData: function fetchAjaxData(data, ajaxurl) {
    return jQuery.ajax({
      type: 'POST',
      url: ajaxurl,
      cache: false,
      dataType: 'json',
      data: data
    });
  },
  getStates: function getStates(e) {
    var country_id = jQuery(this).val();
    var state_selected = jQuery(this).data('state_id');
    var data = {
      country_id: country_id
    };
    jQuery("#rec_state").html('<option value="">--Select State--</option>').prop('disabled', true);
    jQuery("#rec_city").html('<option value="">--Select City--</option>').prop('disabled', true);
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=events.getStates";
    EventEditPage.fetchAjaxData(data, ajaxurl).done(function (response) {
      if (response.error == 0) {
        jQuery("#rec_state").html(' <option value="">--Select State--</option>');
        jQuery.each(response.data, function (key, object) {
          if (state_selected == object.id) {
            jQuery("#rec_state").append(' <option value="' + object.id + '" selected>' + object.name + '</option>');
          } else {
            jQuery("#rec_state").append(' <option value="' + object.id + '">' + object.name + '</option>');
          }
        });
        jQuery("#rec_state").prop('disabled', false);
        if (state_selected != '') jQuery("#rec_state").trigger('change');
      }
    });
  },
  getCities: function getCities(e) {
    var state_id = jQuery(this).val();
    var city_selected = jQuery(this).data('city_id');
    var data = {
      state_id: state_id
    };
    jQuery("#rec_city").html('<option value="">--Select City--</option>').prop('disabled', true);
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=events.getCities";
    EventEditPage.fetchAjaxData(data, ajaxurl).done(function (response) {
      if (response.error == 0) {
        jQuery("#rec_city").html('<option value="">--Select City--</option>');
        jQuery.each(response.data, function (key, object) {
          if (city_selected == object.id) {
            jQuery("#rec_city").append(' <option value="' + object.id + '" selected>' + object.name + '</option>');
          } else {
            jQuery("#rec_city").append(' <option value="' + object.id + '">' + object.name + '</option>');
          }
        });
        jQuery("#rec_city").prop('disabled', false);
      }
    });
  }
};
jQuery(document).ready(function () {
  if (jQuery('#js-evnet-edit').length > 0) {
    EventEditPage.init();
  }
});

},{}],5:[function(require,module,exports){
"use strict";

/* global SITEPATH ACTIVEMEMBERSHIPPLAN */

var ResetPage = {
  init: function init() {
    $(document).on('submit', '#js-forgot-password-form', ResetPage.forgotPassword);
    $(document).on('submit', '#js-verify-updatepwd-form', ResetPage.verifyAndUpdatePwd);
  },
  fetchAjaxData: function fetchAjaxData(data, ajaxurl) {
    return $.ajax({
      type: 'POST',
      url: ajaxurl,
      cache: false,
      dataType: 'json',
      data: data
    });
  },
  //------------------------------------------
  isEmail: function isEmail(email) {
    var re = /^((([0-9]{1,3}\.){3}[0-9]{1,3})|(([a-zA-Z0-9]+(([\-]?[a-zA-Z0-9]+)*\.)+)*[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  forgotPassword: function forgotPassword(e) {
    e.preventDefault();
    var $btn = $(e.currentTarget);
    var $popup = $('#resetEmail');
    $popup.find('.alert').hide();
    var data = {
      user_email: $popup.find('input[name="user_email"]').val()
    };
    var errorObj = {
      status: true,
      msg: ''
    };
    if (data.user_email == '') {
      errorObj.msg = 'Email address is required field.';
    } else if (ResetPage.isEmail(data.user_email)) {
      errorObj.msg = 'Invalid email address.';
    } else {
      ResetPage.email = data.user_email;
      $('#hidden_email').val(ResetPage.email);
      errorObj.status = false;
      $('#resetEmail').find('.form-btn').text('Processing...');
    }
    if (errorObj.status) {
      $('#resetEmail').find('.alert').addClass('alert-danger').html(errorObj.msg).show();
      return false;
    }
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=forgot_passwrod";
    ResetPage.fetchAjaxData(data, ajaxurl).done(function (res) {
      if (typeof res.error != 'undefined' && res.error == '0') {
        $('#resetEmail').hide();
        $('#verifyCode').show();
      } else {
        $('#resetEmail').find('.form-btn').text('Reset Password');
        $('#resetEmail').find('.alert').addClass('alert-danger').html('Invalid email address or not authorized.').show();
      }
    });
  },
  //------------------------------------------
  verifyAndUpdatePwd: function verifyAndUpdatePwd(e) {
    e.preventDefault();
    var $btn = $(e.currentTarget);
    var $popup = $('#verifyCode');
    $popup.find('.alert').hide();
    var data = {
      user_email: $popup.find('input[name="user_email"]').val(),
      user_vcode: $popup.find('input[name="user_vcode"]').val(),
      user_new_password: $popup.find('input[name="user_new_password"]').val()
    };
    if (data.user_email == '' || data.user_vcode == '' || data.user_new_password == '') {
      $('#verifyCode').find('.alert').addClass('alert-danger').html('All fields are required.').show();
      return false;
    } else {
      $('#verifyCode').find('.form-btn').text('Processing...');
    }
    var ajaxurl = SITEPATH + "index.php?option=com_membership&task=verifycode_updatepwd";
    ResetPage.fetchAjaxData(data, ajaxurl).done(function (res) {
      if (typeof res.error != 'undefined' && res.error == '0') {
        $('.updateAfterResult').html('<div class="alert alert-success" role="alert">Password has been successfuly updated.</div>');
        //$('#verifyCode').find('.alert').show();
      } else {
        $('#verifyCode').find('.alert').addClass('alert-danger').html('Invalid verification code or It has been expired.').show();
        $('#verifyCode').find('.form-btn').text('Update Password');
      }
    });
  } //------------------------------------------
};
if ($('#js-reset-page').length > 0) {
  ResetPage.init();
}

},{}]},{},[1]);
